<!--
* @FileDesc: 人才港AI
* @Author: JIE
* @Date: 26/02/03
-->

<template>
    <div class="talent">
        <div class="talent-content" v-html="content"></div>
    </div>
</template>

<script>
    import serveEssay from "@/assets/js/talent.js"
    export default{
        name:'talent',
        data(){
            return {
                content:''
            }
        },

        created(){
            document.title = '人才港AI';
            this.status = this.$route.query.status || 1;
            if(this.status == 1){
            this.content = serveEssay.serve;
            document.title = '人才港AI用户协议';
            }else if(this.status == 2){
            this.content = serveEssay.privacy;
            document.title = '人才港AI隐私政策';

            }
        }
    }
</script>

<style lang="scss" scoped>
    .talent{
        width:100%;
        height: 100%;
        position: fixed;
        top:0;
        left:0;
        overflow: auto;
        .talent-content{
            width:100%;
            padding:20rpx;
            box-sizing: border-box;
        }
    }
</style>